/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Check_Your_EmailInputs */

const en_mobile_check_your_email = /** @type {(inputs: Mobile_Check_Your_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your email`)
};

const es_mobile_check_your_email = /** @type {(inputs: Mobile_Check_Your_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa tu correo`)
};

/**
* | output |
* | --- |
* | "Check your email" |
*
* @param {Mobile_Check_Your_EmailInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_check_your_email = /** @type {((inputs?: Mobile_Check_Your_EmailInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Check_Your_EmailInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_check_your_email(inputs)
	return en_mobile_check_your_email(inputs)
});